import Link from "next/link";
import List from "@mui/material/List";
import {
  ListItemSubmenu,
  MuiListItemText,
  MuiTitleSubmenu,
  SubMenuWrapper,
} from "styles/jss/Navigation.styles";

export default function SubMenu({ menus, onMouseLeave }) {
  return (
    <SubMenuWrapper>
      {menus.map((item, index) => (
        <List key={index} sx={{ width: "100%", maxWidth: 300 }}>
          <MuiTitleSubmenu component="span">{item.name}</MuiTitleSubmenu>
          {item.submenu.map((url, index) => (
            <ListItemSubmenu key={index} onClick={() => onMouseLeave()}>
              <Link href={url.href}>
                <a aria-label={url.name}>
                  <i className="icon">{url.icon}</i>
                  <MuiListItemText primary={url.name} />
                </a>
              </Link>
            </ListItemSubmenu>
          ))}
        </List>
      ))}
    </SubMenuWrapper>
  );
}
